import React, { useState } from 'react';
import { useModal } from '../../../../hooks/ModalContext';
import { useDividas } from '../../../../context/DividasContext';
import { IoSearchCircle } from 'react-icons/io5';

export const BuscarDevedor = () => {
  const { onClose } = useModal();
  const { getDividas } = useDividas()
  const [cpf, setCpf] = useState('')
  // const { dadosChamada } = useContext(DiscadorContext);

  // const {} =
  // const themeModal: CustomFlowbiteTheme['modal'] = {
  //   root: {
  //     base: 'fixed top-0 right-0 left-0 z-50 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full',
  //   },
  // };
  function maskCPFCNPJ(value: string) {
    if (value.length >= 15) {
      return value
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  }

  async function handleSearch() {
    await getDividas({ cpf_cnpj: cpf.replace(/\D/g, ''), codcredor: 0 })
    // await getDevedorCadastro(url_ws, cpf.replace(/\D/g, ''), codcredor);
    // await getDividasGazin({ cpf_cnpj: cpf.replace(/\D/g, '') })
    setCpf('')
    onClose()
  }


  return (
    <>
      <div className="flex flex-col px-4 pb-4 text-gray-800">
        <div className="flex w-full items-center justify-center gap-2 -mt-4">
          {/* <MdInfoOutline className="fill-primary" size={24} /> */}
          <h3 className="my-4 text-lg font-semibold text-primary">Buscar Devedor</h3>
        </div>
        <div>
          <p>Digite o CPF/CNPJ: </p>
          <div className='flex items-center w-full'>
            <input type={'text'} maxLength={18} value={maskCPFCNPJ(cpf)} className='input-container  bg-white' onChange={(e) => setCpf(e.target.value)} />

            <button>
              <IoSearchCircle size={48} className='fill-primary' onClick={() => handleSearch()} />
            </button>
          </div>
        </div>
        {/* <button className="-mb-4 mt-4 rounded-md bg-error p-2 font-semibold text-white" onClick={() => {
          setCpf('')
          onClose()
        }}>Fechar</button> */}
      </div>
    </>
  );
};
